import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box,
    IconButton,
    Typography,
    Select,
    MenuItem,
    Grid,
    Snackbar,
    FormControl,
    InputLabel,
    ListSubheader,
    Alert, Autocomplete, Divider, createFilterOptions
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link } from 'react-router-dom';
import { quantum, trio } from 'ldrs';
import { styled, keyframes } from '@mui/system';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import HomeIcon from '@mui/icons-material/Home';
import Bankamount from '../component/Incomeandexpenses/Bankamount';
import { useNavigate } from "react-router-dom";
import { Notyf } from 'notyf';

const notyf = new Notyf({
    position: { x: 'left', y: 'bottom' },
    duration: 3000,
});

const slideInFromLeft = keyframes`
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

const AnimatedTypography = styled(Typography)(({ theme }) => ({
    animation: `${slideInFromLeft} 0.5s ease-out`,
}));

quantum.register();
trio.register();

const Expenses = () => {
    const [user, setUser] = useState({});
    const [token, setToken] = useState(() => localStorage.getItem('token') || null);
    const [rows, setRows] = useState([{ category: '', amount: '' }]);
    const [fullname, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [paymenttype, setPaymenttype] = useState('');
    const [phone, setPhone] = useState('');
    const [type, setType] = useState('');
    const [description, setDescription] = useState('');
    const [date, setDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [expenses, setExpenses] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [totalBankAmount, setTotalBankAmount] = useState(0);
    const [investments, setInvestments] = useState([]);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [finalTotal, setFinalTotal] = useState(0);


    const handleSnackbar = (message, severity) => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    useEffect(() => {
        if (token) {
            localStorage.setItem('token', token);
        }
    }, [token]);

    {/**useEffect(() => {
        const fetchProfile = async () => {
            if (!token) return;

            try {
                const response = await axios.get('https://admin.bizstor.lk/public/api/profile', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setUser(response.data);
            } catch (error) {
                console.log('');
            }
        };

        fetchProfile();
    }, [token]);*/}

    useEffect(() => {
        const fetchProfile = async () => {
            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/"); // Redirect if no token
                return;
            }

            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setUser(response.data);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/");
                }
            }
        };

        fetchProfile();
    }, []);

    useEffect(() => {
        if (user.id) {
            fetchData();
            fetchCustomers();
            fetchSuppliers();
        }
    }, [user.id]);

    const handleAddRow = () => {
        setRows([...rows, { category: '', amount: '' }]);
    };

    const handleDeleteRow = (index) => {
        const newRows = rows.filter((row, i) => i !== index);
        setRows(newRows);
    };

    const handleInputChange = (index, field, value) => {
        const newRows = rows.map((row, i) => {
            if (i === index) {
                return { ...row, [field]: value };
            }
            return row;
        });
        setRows(newRows);
    };

    const fetchData = () => {
        setLoading(true);

        axios.get('https://admin.bizstor.lk/public/api/get-expenses-category-data')
            .then(response => {
                if (user.id) {
                    const Expenses = response.data.expenses.filter(expense =>
                        expense.usertoken.toString().toLowerCase() === user.id.toString().toLowerCase() ||
                        expense.usertoken === "0"
                    );
                    setExpenses(Expenses);
                }

                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching product data:', error);
                setLoading(false);
            });
    };


    const fetchCustomers = async () => {
        setLoading(true);
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-customer-data');
            if (user.id) {
                const Customers = response.data.customers.filter(customer =>
                    customer.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                );
                setCustomers(Customers);

            }
        } catch (error) {
            console.error('Error fetching customers:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCustomers();
    }, []);


    const fetchSuppliers = async () => {
        try {
            setLoading(true);

            const response = await axios.get('https://admin.bizstor.lk/public/api/suppliers');
            if (user.id) {
                const Supplier = response.data.filter(supplier =>
                    supplier.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                );
                setSuppliers(Supplier);
            }

        } catch (error) {
            console.error('Error fetching suppliers:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSuppliers();
    }, []);

    useEffect(() => {
        fetchData();
    }, []);

    const handleSelectChange = (event) => {
        const selectedValue = event.target.value;

        const selectedCustomer = customers.find(customer => customer.firstname === selectedValue);
        const selectedSupplier = suppliers.find(supplier => supplier.supplier_name === selectedValue);

        if (selectedCustomer) {
            setFullName(selectedCustomer.firstname);
            setEmail(selectedCustomer.email);
            setPhone(selectedCustomer.phone || '');
        } else if (selectedSupplier) {
            setFullName(selectedSupplier.supplier_name);
            setEmail(selectedSupplier.email);
            setPhone('');
        }

        setType(selectedValue);
    };

    const handleSubmit = async () => {
        setLoading(true);

        const hasInvalidRow = rows.some(row => !row.category || !row.amount);

        const currentPaymentType = String(paymenttype || '').trim();

        if (!currentPaymentType) {
            //handleSnackbar('Please select the payment type', 'error');
            notyf.error('payment type is required!');
            setLoading(false);
            return;
        }
        if (hasInvalidRow) {
            //handleSnackbar('Please fill in all required category and amount fields.', 'error');
            notyf.error('Category and amount fields is required!');
            setLoading(false);
            return;
        }



        try {
            const data = {
                usertoken: user.id,
                fullname: fullname,
                email: email,
                paymenttype: paymenttype,
                phone: phone,
                type: type,
                pay_id: `EXP-${Date.now()}`,
                date: date || new Date().toISOString().split('T')[0],
                description: description,
                items: rows.map(row => ({
                    category: row.category,
                    amount: row.amount,
                }))
            };


            const response = await axios.post('https://admin.bizstor.lk/public/api/save-expense-data', data);

            setPhone('');
            setPaymenttype('');
            setType('');
            setFullName('');
            setEmail('');
            setDate('');
            setDescription('');
            setRows([{ category: '', amount: '' }]);
            //handleSnackbar('Expenses save successfully!', 'success');
            notyf.success('Expenses created successfully!');
            setLoading(false);
            fetchData();
        } catch (error) {
            //console.error('Error saving data:', error);
            notyf.error('Something went wrong!');
        } finally {
            setLoading(false);
        }
    };


    const handleTotalAmountChange = (amount) => {
        setFinalTotal(amount);
    };

    const expenseCategoryOptions = expenses.flatMap(expense => {
        if (expense.subexpenses && expense.subexpenses.length > 0) {
            return expense.subexpenses.map(subexpense => `${expense.expenses} - ${subexpense.subexpense}`);
        }
        return [expense.expenses];
    });

    return (
        <Box
            sx={{
                mt: 10,
                mb: 5
            }}
        >
            <AnimatedTypography
                component="h1"
                sx={{
                    ml: { xs: 2, sm: 3 },
                    mt: { xs: 2, sm: 3 },
                    color: '',
                    letterSpacing: '0.01em',
                    fontSize: { xs: '20px', sm: '24px' },
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                    {/**<Typography
                        component="span"
                        sx={{
                            display: { xs: 'none', sm: 'inline' },
                            fontSize: { xs: '14px', sm: '16px' },
                            fontWeight: 'bold',
                            color: '',
                        }}
                    >
                        Expenses
                    </Typography>
                    <Typography
                        component="span"
                        sx={{
                            display: { xs: 'none', sm: 'inline' },
                            ml: 1,
                            fontSize: '14px',
                            color: '',
                        }}
                    >
                        |
                    </Typography>*/}
                    <HomeIcon
                        sx={{
                            ml: 1,
                            fontSize: '18px',
                            color: '#6d7081',
                        }}
                    />
                    <Typography
                        component="span"
                        sx={{
                            ml: 0.5,
                            fontSize: '14px',
                            color: '#6d7081',
                        }}
                    >
                        - Expenses
                    </Typography>
                </Box>
            </AnimatedTypography>

            {/**<AnimatedTypography
                component="h1"
                sx={{
                    ml: 3,
                    mt: 3,
                    fontSize: '1rem',      
                    color: 'secondary.main',
                    letterSpacing: '0.01em' ,
                }}
            >
                Dashboard / Expenses
            </AnimatedTypography>*/}

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: {sm:'95%',xs:'90%'},
                    maxWidth: 'auto',
                    margin: 'auto',
                    padding: '10px',
                    bgcolor: 'background.paper',
                    border: '1px solid #EDF2F7',
                    borderRadius: '16px',
                    marginTop: '30px',
                    position: 'relative',
                    marginBottom: '20px'
                }}
            >
                <Typography variant="h5"
                    sx={{
                        ml: 2
                    }}
                >
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        '@media (max-width: 600px)': {
                            margin: 'auto',
                        },
                        color: '#1e293b',
                        ml: 2
                    }}
                >
                    <h2>Expenses</h2>
                </Box>

                <TableContainer>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={4}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <FormControl variant="outlined" fullWidth size="small">
                                                <InputLabel>Select Person</InputLabel>
                                                <Select
                                                    value={type}
                                                    onChange={handleSelectChange}
                                                    label="Select Person"
                                                    fullWidth
                                                >
                                                    <ListSubheader>Customers</ListSubheader>
                                                    {customers.length > 0 && customers.map(customer => (
                                                        <MenuItem key={customer.id} value={customer.firstname}>
                                                            {customer.firstname}
                                                        </MenuItem>
                                                    ))}
                                                    <ListSubheader>Suppliers</ListSubheader>
                                                    {suppliers.map(supplier => (
                                                        <MenuItem key={supplier.id} value={supplier.supplier_name}>
                                                            {supplier.supplier_name}
                                                        </MenuItem>
                                                    ))}
                                                    <Divider sx={{ my: 0.5 }} />
                                                    <MenuItem value="" >
                                                        <Link to="/addcustomer" style={{ textDecoration: 'none', color: 'inherit', }}>
                                                            + Add New Customer
                                                        </Link>
                                                    </MenuItem>
                                                    <MenuItem value="">
                                                        <Link to="/addsupplier" style={{ textDecoration: 'none', color: 'inherit' }}>
                                                            + Add New Supplier
                                                        </Link>
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextField
                                                label="Full Name"
                                                value={fullname}
                                                onChange={(e) => setFullName(e.target.value)}
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextField
                                                label="Email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <FormControl variant="outlined" fullWidth size="small">
                                                <InputLabel>Payment Type</InputLabel>
                                                <Select
                                                    value={paymenttype}
                                                    onChange={(e) => setPaymenttype(e.target.value)}
                                                    label="Payment Type"
                                                    fullWidth
                                                >
                                                    <MenuItem value="Paid">Paid</MenuItem>
                                                    <MenuItem value="Credit">Credit</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell colSpan={4}>
                                    <Grid container spacing={2} justifyContent="flex-start">
                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextField
                                                type="date"
                                                label="Date"
                                                value={date || new Date().toISOString().split('T')[0]}
                                                onChange={(e) => setDate(e.target.value)}
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>

                                    </Grid>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'right',
                            justifyContent: 'flex-end',
                            marginTop: '10px',
                            marginRight: '15px',
                            textAlign: 'right',
                        }}
                    >
                        <Typography variant="subtitle1">
                            BANK BALANCE
                        </Typography>
                        <Typography variant="h4" fontWeight="bold">
                            LKR.{finalTotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'right',
                            justifyContent: 'flex-end',
                            marginTop: '10px',
                            marginRight: '15px',
                            textAlign: 'right',
                        }}
                    >
                        <Typography variant="subtitle1">
                            TOTAL AMOUNT
                        </Typography>
                        <Typography variant="h4" fontWeight="bold">
                            LKR.{rows.reduce((sum, row) => sum + parseFloat(row.amount || 0), 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </Typography>
                    </Box>
                </Box>


                {/** <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    padding: '10px',
                    marginTop: '10px',
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 'bold',
                        fontSize: '1.25rem', // Adjust size as needed
                    }}
                >
                    Total : LKR {rows.reduce((sum, row) => sum + parseFloat(row.amount || 0), 0).toFixed(2)}
                </Typography>
            </Box>*/}

                <TableContainer style={{ marginTop: '20px', }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Category</TableCell>
                                <TableCell>Amount</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>
                                        <FormControl fullWidth>
                                            <Autocomplete
                                                value={row.category}

                                                onChange={(event, newValue) => {
                                                    if (typeof newValue === 'string') {
                                                        handleInputChange(index, 'category', newValue);
                                                    } else if (newValue && newValue.inputValue) {
                                                    } else {
                                                        handleInputChange(index, 'category', '');
                                                    }
                                                }}

                                                options={expenseCategoryOptions}

                                                getOptionLabel={(option) => option}

                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        size="small"
                                                        sx={{
                                                            width: '300px',
                                                            '@media (max-width: 600px)': {
                                                                width: '200px',
                                                            },
                                                        }}
                                                    />
                                                )}

                                                renderOption={(props, option) => (
                                                    <li {...props}>
                                                        {option}
                                                    </li>
                                                )}

                                                ListboxComponent={React.forwardRef((props, ref) => (
                                                    <ul ref={ref} {...props}>
                                                        {props.children}
                                                        <Divider sx={{ my: 0.5 }} />
                                                        <MenuItem>
                                                            <Link to="/addexpenses" style={{ textDecoration: 'none', color: 'inherit', width: '100%' }}>
                                                                + Add New Expenses
                                                            </Link>
                                                        </MenuItem>
                                                    </ul>
                                                ))}

                                                sx={{
                                                    width: '300px',
                                                    '@media (max-width: 600px)': {
                                                        width: '200px',
                                                    },
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            //label="Amount"
                                            value={row.amount}
                                            onChange={(e) => handleInputChange(index, 'amount', e.target.value)}
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            sx={{
                                                width: '200px'
                                            }}
                                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <IconButton onClick={() => handleDeleteRow(index)}>
                                            <DeleteIcon
                                                sx={{
                                                    '&:hover': {
                                                        color: 'red',
                                                    },
                                                }} />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={handleAddRow}
                        style={{ backgroundColor: 'black', color: 'white' }}
                    >
                        <PlaylistAddIcon />
                    </Button>
                </Box>
                <TextField
                    label="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    variant="outlined"
                    fullWidth
                    size="small"
                    multiline
                    minRows={3}
                    sx={{
                        width: { sm: '50%', md: '50%', xs: '100%' },
                        mt: 3
                    }}
                />

                <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        style={{
                            backgroundColor: '#4287f5',
                            color: 'white',
                            marginTop: '30px',
                            borderRadius: '20px',
                            padding: '8px 24px',
                            '&:hover': {
                                backgroundColor: '#356bc4',
                            },
                            marginBottom: { xs: '8px', sm: '0' }
                        }}
                        value='save'
                    >
                        Submit
                    </Button>
                </Box>

                {loading && (
                    <Box sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'white',
                        zIndex: 9999
                    }}>
                        <l-trio
                            size="50"
                            speed="1.3"
                            color="red"
                        ></l-trio>
                    </Box>
                )}

                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                >
                    <Alert
                        onClose={handleSnackbarClose}
                        severity={snackbarSeverity}
                        sx={{
                            width: '100%',

                        }}
                    >
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </Box>
        </Box>
    );
};

export default Expenses;
